exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".invalidPage__text___gfJiT {\n  margin: 100px 0;\n  font-size: 24px;\n  padding: 0 15px; }\n  @media (max-width: 576px) {\n    .invalidPage__text___gfJiT {\n      margin: 50px 0;\n      font-size: 20px;\n      padding: 0 30px; } }\n\n.invalidPage__button___3das6 {\n  margin: 50px 15px;\n  height: 50px; }\n  @media (max-width: 576px) {\n    .invalidPage__button___3das6 {\n      margin: 0px 15px 50px 15px;\n      width: calc(100% - 30px); } }\n", ""]);

// exports
exports.locals = {
	"text": "invalidPage__text___gfJiT",
	"button": "invalidPage__button___3das6"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/InvalidPage/invalidPage.scss
// module id = 4674
// module chunks = 6